import { render, staticRenderFns } from "./RoleTableCell.vue?vue&type=template&id=c2c0e97c&scoped=true"
import script from "./RoleTableCell.vue?vue&type=script&lang=js"
export * from "./RoleTableCell.vue?vue&type=script&lang=js"
import style0 from "./RoleTableCell.vue?vue&type=style&index=0&id=c2c0e97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0e97c",
  null
  
)

export default component.exports